import { render, staticRenderFns } from "./FullScreenBankBranchSearch.vue?vue&type=template&id=5a88aa06&"
import script from "./FullScreenBankBranchSearch.vue?vue&type=script&lang=js&"
export * from "./FullScreenBankBranchSearch.vue?vue&type=script&lang=js&"
import style0 from "./FullScreenBankBranchSearch.vue?vue&type=style&index=0&id=5a88aa06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports